import jovenesTalentos from './jovenes-talentos'
import avisoItEcommerce from './aviso-it-ecommerce'
import ecommerce from './ecommerce'
import newUserProfile from './new-user-profile'
import newCompanyProfile from './new-company-profile'
import newEcommerce from './new-ecommerce' /** Se migra la landing de productos de grails a react */
import bannerAdvertisingHome from './banner-advertising-home'
import resumenCuenta from './resumen-cuenta'
import newAvisoPublicacionProductos from './new-aviso-publicacion-productos'

const all = {
  jovenesTalentos,
  avisoItEcommerce,
  ecommerce,
  newUserProfile,
  newCompanyProfile,
  newEcommerce,
  bannerAdvertisingHome,
  resumenCuenta,
  newAvisoPublicacionProductos,
}

export default all
